module.exports = __webpack_public_path__ + "static/media/Cocaine.2a878018.svg";